import type { CustomProps } from '../../common'
import type { ComponentDefinition } from '../component-definition'
import type { ShellExtension, ShellExtensionRegisterApplicationConfig } from '../shell-extension'
import type { RouteMatcher, ShellModule } from '../shell-module'

export function isPathMatchingRoute(path: string, route: RouteMatcher) {
  return route instanceof RegExp ? path.match(route) : path === route
}

/**
 * @private
 * Creates an application configuration object (single-spa) for a given module.
 * @param extension Shell extension instance that contains the module
 * @param module Module for which to create a single-spa application
 * @returns created single-spa configuration object
 */
export function createAppForExtensionModule(
  extension: ShellExtension,
  module: ShellModule,
): ShellExtensionRegisterApplicationConfig<CustomProps> {
  const name = `${extension.id}/${module.displayNameKey}/${module.componentId}`
  const routes: RouteMatcher[] = [...module.routes]

  return {
    name,
    routes,
    activeWhen: location => routes.some(route => isPathMatchingRoute(location.pathname, route)),
    // TODO handle null component definition https://jira.ops.expertcity.com/browse/SCORE-1405
    app: () => extension.getComponentById(module.componentId) as Promise<ComponentDefinition>,
    customProps: {
      shellConfig: module.shellConfig ?? {},
    },
  }
}
